import React from "react";

const Blogtwo = () => {
  return (
    <div>
      <div>
        <p className="text-2xl font-bold    py-5 px-10">
          Healthcare services at your doorstep riding on power of technology
        </p>
        <p className="text-xl      px-10">Healthcare  at Home</p>
        <p className="text-xl      px-10">09 January 2023, 21:55</p>
        <img
          className="py-5  px-10 rounded-md  	"
          src="https://cdn.jagonews24.com/media/imgAllNew/BG/2019November/dd-20230110120818.jpg"
          alt=""
        />
        <p className="px-10 py-2">
          Jahanara Begum (65) lives in Gulshan. She has to stay alone all day in
          a big house. However, there are some domestic helps to help him.
          Rafsan Zaman, the only child, lives in America with his wife and
          children in order to earn a living. Jahanara Begum has lost a step and
          her body does not support her will equally owing to her age.
          Consequently, anything can happen anytime. On the other hand, her son
          always worries about mother’s health. Rafsan Zaman suddenly received a
          call from the house help one day in the middle of December. As soon as
          he answered the phone, he heard the sound of crying. 
</p>
          
         <p className="px-10 py-2">
         From the other
          end, the maid said that aunt’s (his mother) health is deteriorating.
          She has to be taken to the hospital immediately. Rafsan felt very
          anxious at the thought of who would take her to the hospital in this
          hour of the night. Rafsan's wife Tania Begum was sitting next to him.
          Suddenly she started talking to someone over the phone. Later, Rafsan
          came to know that Tania called the emergency number of ‘Health Care At
          Home’ (HCAH) and requested to send a doctor and nurse to her
          mother-in-law’s home.

         </p>
         <p className="px-10 py-2">
         Within the next 10 minutes, a doctor and a nurse
          arrived at her mother-in-law’s house in Gulshan. Jahanara Begum
          started to feel a little better within the next few hours after
          receiving primary treatment. With the help of technology, every day
          hundreds of people like Jahanara Begum are taking healthcare services
          at home as per their necessities.

         </p>
         <p className="px-10 py-2">
         The global Covid-19 pandemic has
          taught us many things. The first and most important of these is to
          ensure the protection of our health and to be more careful about it.
          The situation caused by the global pandemic has also brought to the
          fore the significance pf innovation in the health sector. The pandemic
          has strengthened the health sector ecosystem of the country by
          introducing new technologies in this sector and bringing advanced
          modules. One of the new ideas implemented with the help of advanced
          technology in the field of healthcare was to avail healthcare services
          from the comfort of home. In adverse times like Covid, such activities
          have been appreciated in most countries including Bangladesh and have
          played an important role in meeting the healthcare needs.

         </p>
         <p className="px-10 py-2">
         During the
          pandemic, most hospitals in the country had to serve more patients
          than their capacity. Even then, many patients have to face
          difficulties in accessing services due to immense pressure. At that
          time, all the innovative initiatives played an important role in the
          healthcare sector. As a result of these initiatives, people have been
          able to get healthcare facilities at affordable cost at home. Besides,
          many of these new initiatives are working on to address and minimize
          the limitations that patients usually have to go through while
          receiving treatment, such as: proper healthcare planning, real-time
          monitoring of patients and timely logistics support. One such
          innovative initiative is ‘Health Care At Home’ (HCAH). Established in
          2019, the healthcare provider started its operations back in February
          2020. This initiative has already been praised for starting the
          journey with the groundbreaking idea of bringing healthcare to
          people’s doorsteps. Services provided by HCAH include nursing, medical
          caregiving, physiotherapy, medical assistance, counseling and
          companionship. Besides, medical equipment facility can also be availed
          from HCAH. The staff of HCAH have experience of working in various
          reputed medical institutions. 

         </p>
         <p className="px-10 py-2">
         The organization has brought home-based
          services to specially-abled children and dementia patients for the
          first time in the country. The organization is committed to serving
          patients anytime, anywhere. Besides, HCAH guarantees 100% transparency
          in service delivery. Those interested in taking the services of HCAH
          can contact the organization through Facebook, LinkedIn or website at
          their convenience. 

         </p>
         <p className="px-10 py-2">
          
         HCAH will then assess the patient’s health status
          and create a tailored health plan. Next, the patient will be offered
          the freedom to choose from a list of suitable healthcare providers to
          serve them. HCAH ensures 24/7 monitoring and supervision of patients
          as well. This service provider has not limited its activities only to
          providing quality services to patients. HCAH is also offering B.Sc
          degree through the State College of Health Sciences affiliated to
          Dhaka University to create skilled manpower to meet the growing needs
          of the country’s healthcare sector.

         </p>

           
          
       

          

          
     
      </div>
    </div>
  );
};

export default Blogtwo;
